var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCavernicolappFlame({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fire",
    x1: 120,
    y1: 410,
    x2: 410,
    y2: 82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F72585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF6B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC857"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287 42C300 115 249 139 264 205C277 179 304 161 337 154C323 202 389 226 389 315C389 396 330 456 249 456C168 456 110 398 110 319C110 248 158 214 196 176C213 159 229 134 226 98C278 124 295 168 291 207C321 170 321 103 287 42Z",
    fill: "url(#fire)",
    filter: "url(#glow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252 247C267 285 232 304 245 334C255 317 272 307 291 306C286 327 309 341 309 371C309 408 283 434 248 434C213 434 186 409 186 374C186 343 204 326 220 310C236 294 246 275 252 247Z",
    fill: "#0F172A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227 382C227 365 240 352 257 352C268 352 278 358 283 367C278 365 273 364 267 364C248 364 233 378 231 397C228 393 227 388 227 382Z",
    fill: "white",
    fillOpacity: 0.92
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCavernicolappFlame);
export default __webpack_public_path__ + "static/media/cavernicolapp-flame.31b1c1720bc0c63e0b58021f0583aec8.svg";
export { ForwardRef as ReactComponent };